import axiosInstance from './axiosInstance';

export const getMyWallets        = () => axiosInstance.get('/wallet/me');
export const getMyTransactions   = (type) => axiosInstance.get('/wallet/transactions', { params: { type } });
export const getMyRewards        = () => axiosInstance.get('/wallet/rewards');
export const getMyMilestoneRewards = () => axiosInstance.get('/wallet/milestone-rewards');
export const lookupUser          = (code) => axiosInstance.get('/wallet/lookup-user', { params: { code } });
export const p2pTransfer         = (data) => axiosInstance.post('/wallet/p2p-transfer', data);
export const sendP2POTP          = () => axiosInstance.post('/wallet/send-p2p-otp');
export const verifyAndP2PTransfer = (data) => axiosInstance.post('/wallet/verify-p2p-transfer', data);
export const getMyP2PTransfers   = () => axiosInstance.get('/wallet/p2p-transfers');
export const createWithdrawal    = (data) => axiosInstance.post('/withdrawals', data);
export const sendWithdrawalOTP   = () => axiosInstance.post('/withdrawals/send-otp');
export const verifyAndProcessWithdrawal = (data) => axiosInstance.post('/withdrawals/verify-and-process', data);
export const getMyWithdrawals    = () => axiosInstance.get('/withdrawals/my');
export const cancelWithdrawal    = (id) => axiosInstance.patch(`/withdrawals/${id}/cancel`);
export const getWithdrawalLimit  = () => axiosInstance.get('/wallet/withdrawal-limit');
export const getWithdrawalSummary = () => axiosInstance.get('/wallet/withdrawal-summary');
export const getMainWalletSummary = () => axiosInstance.get('/wallet/main-summary');
export const getOneWalletSummary = () => axiosInstance.get('/wallet/one-summary');
export const getWithdrawalFees   = () => axiosInstance.get('/withdrawals/fees');

// NowPayments USDT deposit
export const createPaymentRequest = (data) => axiosInstance.post('/wallet/create-payment', data);
export const getPaymentStatus = (paymentId) => axiosInstance.get(`/wallet/payment/${paymentId}`);
export const getPaymentHistory = () => axiosInstance.get('/wallet/payment-history');
